<template>
  <div class="recharge">
    <van-nav-bar :title="$t('infomation.recharge')" left-text="" @click-left="onClickLeft" left-arrow class="custom-navbar"></van-nav-bar>

    <div class="top">
      <div>
        <van-image round width="4.2rem" height="4.2rem" :src="this.userInfo.header_img" >
          <template v-slot:loading>
            <van-loading type="spinner"/>
          </template>
        </van-image>
        <div class="info">
          <p class="username">
            {{this.userInfo.username}}
          </p>
          <p class="balance">
            {{$t('infomation.amount')}}：{{this.userInfo.money}} TRY
          </p>
        </div>
      </div>
    </div>
    
    <div class="kfsm">
      <div class="kf-icon">
        <van-icon name="service" size="1.5rem" color="#667eea" />
      </div>
      <p>
        {{$t('infomation.kfms')}}
      </p>
    </div>
    
    <div class="kf">
      <van-button type="primary" round block size="large" @click="toService" class="service-btn">
        {{$t('infomation.toserve')}}
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      menu_top: 40,
      isLoading: false,
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.$toast(this.$t('common.refresh'));
        } else {
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },

    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if(localStorage.getItem('token')){
          this.getUserInfo();
          this.$toast(this.$t('common.refresh'));
        } else {
          this.$router.push({path:'/Login'})
        }
      }, 500);
    },
    
    onClickLeft() {
      this.$router.push("Mine");
    },

    toService() {
      if(this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast.fail(this.$t('common.noallow'));
      }
    },
    
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if(res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          if(this.userInfo.status !== 1) {
            this.$toast(this.$t('accountOffline'));
            localStorage.clear()
            this.$router.push({path:'/Login'})
          }
        } else if(res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if(localStorage.getItem('token')) {
      this.getUserInfo();
    } else {
      this.userInfo.username = this.$t('loginRegister');
      this.userInfo.ip = this.$t('loginForMore');
      this.userInfo.header_img = "img/mine/avatar.png";
    }
  }
};
</script>

<style scoped>
:export {
  gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.recharge {
  width: 100%;
  min-height: 100vh;
  background: #f8f9ff;
}

.custom-navbar {
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%) !important;
}

.custom-navbar ::v-deep .van-nav-bar__content {
  background: transparent;
}

.custom-navbar ::v-deep .van-nav-bar__title {
  color: #fff;
  font-weight: 600;
  font-size: 18px;
}

.custom-navbar ::v-deep .van-icon {
  color: #fff;
  font-size: 20px;
}

.top {
  width: 100%;
  background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
  padding: 5rem 5% 2rem;
  border-radius: 0 0 30px 30px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);
}

.top > div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.top .van-image {
  border: 4px solid rgba(255, 255, 255, 0.8);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
}

.info {
  text-align: left;
  color: #fff;
  padding-left: 1.5rem;
  flex: 1;
}

.username {
  font-size: 1.2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.balance {
  font-size: 0.9rem;
  opacity: 0.9;
  margin: 0;
}

.kfsm {
  width: 90%;
  margin: 2rem auto;
  display: flex;
  align-items: center;
  background: #fff;
  padding: 1.2rem 1.5rem;
  border-radius: 20px;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.1);
  border-left: 4px solid #667eea;
}

.kf-icon {
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: rgba(102, 126, 234, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.kfsm p {
  text-align: left;
  padding-left: 1rem;
  font-size: 0.85rem;
  color: #666;
  line-height: 1.5;
  margin: 0;
  flex: 1;
}

.kf {
  margin-top: 3rem;
  padding: 0 5%;
}

.service-btn {
  background: linear-gradient(135deg, #3498db, #8e44ad) !important;
  border: none !important;
  height: 3rem;
  font-size: 1rem;
  font-weight: 600;
  color: #fff;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
  transition: all 0.3s ease;
}

.service-btn:active {
  transform: translateY(2px);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.4);
}

/* 响应式设计 */
@media (max-width: 768px) {
  .custom-navbar ::v-deep .van-nav-bar__title {
    font-size: 16px;
  }
  
  .custom-navbar ::v-deep .van-icon {
    font-size: 18px;
  }
  
  .top {
    padding: 4rem 5% 1.5rem;
    border-radius: 0 0 25px 25px;
  }
  
  .username {
    font-size: 1.1rem;
  }
  
  .balance {
    font-size: 0.85rem;
  }
  
  .kfsm {
    width: 88%;
    margin: 1.5rem auto;
    padding: 1rem 1.2rem;
  }
  
  .kfsm p {
    font-size: 0.8rem;
  }
  
  .kf {
    margin-top: 2.5rem;
  }
  
  .service-btn {
    height: 2.8rem;
    font-size: 0.95rem;
  }
}

/* 动画效果 */
.top {
  animation: slideDown 0.6s ease-out;
}

.kfsm {
  animation: fadeInUp 0.6s ease-out 0.2s both;
}

.kf {
  animation: fadeInUp 0.6s ease-out 0.4s both;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>